<template>
  <div class="encuesta-graph">
    <div class="candidate-bar">
      <div class="bar-wrapper">
        <div class="y-axis">
          <span class="percent" :style="`bottom: ${calcScale(20)}px`">20%</span> 
          <span class="percent" :style="`bottom: ${calcScale(15)}px`">15%</span> 
          <span class="percent" :style="`bottom: ${calcScale(10)}px`">10%</span> 
          <span class="percent" :style="`bottom: ${calcScale(5)}px`">5%</span> 
          <span class="percent" :style="`bottom: ${calcScale(0)}px`" >0%</span>
        </div>
      </div>
      <span class="label"></span>        
      <span class="candidate-img"></span>  
      <span class="label-partido"></span>
    </div>               
    <div class="candidate-bar" :key="kebabCase(c.options)" v-for="c in data">                
      <div>
        <div class="bar-wrapper" :style="{'background-color': `${c.color}ba`}">
          <span class="bar" :style="{'height': 130 - calcScale(c.date_one) + `px` }"></span>
          <span class="bar-label">{{ c.date_one }}%</span>
        </div>
  
        <div class="w-bar-content">
          <span class="label">{{ c.options }}</span>  
          <div class="mt-4 text-center">
            <span class="label-partido"><img v-if="c.partido"  class="partido-bar" :src="`./assets/${kebabCase(c.partido)}.png`" alt="s"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="candidate-bar" v-for="b in noParty" :key="kebabCase(b.options)">                
      <div class="bar-wrapper" v-if="b.date_one > 0" :style="{'background-color': `#063e2c45`}">
        <span class="bar" :style="{'height': 130 - calcScale(b.date_one) + `px` }"></span>
        <span class="bar-label">{{ b.date_one }}%</span>
      </div>
      <span class="label" v-if="b.date_one > 0">{{ b.options }}</span>  
      <span class="label-partido" v-if="b.date_one > 0"></span>
      <span class="candidate-img" v-if="b.date_one > 0"></span>
    </div>
    <div class="row">
      <div class="col-12 col-md-12">
        <div class="note">
          Margen de error +- 3.1%
        </div>
      </div>      
    </div>
  </div>
</template>

<script>

  import { kebabCase } from 'lodash'
  import * as d3 from 'd3'

  export default {
    name: "barVerticalChart",
    props: {
      data: Array,
      noParty: Array,
      vertical: Boolean,
      header: Object,      
    },
    methods: {
      kebabCase,
      calcScale(porcentaje) {
        let myScale = d3.scaleLinear()
          .domain([0, 25])
          .range([0, 130]);
        return myScale(porcentaje)
      }
    }
  }

</script>

<style lang="scss">

.w-bar-content {
  height: 78px;
  position: relative;
}

.foto-bar {
	width: 30px;
	height: 30px;
	-moz-border-radius: 50%;
	-webkit-border-radius: 50%;
	border-radius: 50%;	
	margin-right: auto;
	margin-left: auto;
	border: none;
}

@media (max-width: 600px) {
  .foto-bar {
    width: 54px;
		height: 54px;
		-moz-border-radius: 50%;
		-webkit-border-radius: 50%;
		border-radius: 50%;	
		margin-right: 5PX;
		margin-left: 5PX;
		border: solid 3px;
  }
}

.foto-bar img {
	width: 34px;
	height: 34px;
	-moz-border-radius: 50%;
	-webkit-border-radius: 50%;
	border-radius: 50%;	
}

@media (max-width: 600px) {
  .foto-bar img {
		width: 48px;
		height: 48px;
		-moz-border-radius: 50%;
		-webkit-border-radius: 50%;
		border-radius: 50%;
    
  }
}



.encuesta-graph {
    display: flex;
    align-items: flex-end;
    max-width: 100%;
    margin: 10px auto;
    padding: 5px 0;
    border-bottom: solid 1px #a8a7a785;

    .y-axis {
      position: relative;
      width: 10px;
      height: 130px;
      margin: 0 5px;
      font-size: 10px;

      span.percent {
        position: absolute;
        width: 640px;
        line-height: 0;
        border-top: dashed 1px #a8a7a785
      }
    }
  
    .candidate-bar {
      float: left;
      width: 40px;    
      margin: 0 10px;

      .bar-label {
        display: block;
        margin-top: -15px;
        font-size: 12px;
        font-weight: 900;
        text-align: center;

        img {
          width: 35px;
        }
      }
  
      .bar-wrapper {
        width: 100%;
        height: 130px;
      }
  
      .bar {
        display: block;
        width: 100%;
        background: #fff;
        transition: height .15s ease-in-out;
      }
    }

    .label {
      display: block;
      height: 13px;
      margin: 6px 0 0 0;
      font-size: 10px;
      font-weight: 400;
      line-height: 1em;
      text-align: center;
      color: #565656;
      transform: rotate(0deg);
    }

    .candidate-img {
      display: block;
      width: 43px;
      height: 35px;
      margin: 20px 0 10px 0;
      opacity: 0.9;

      img {
        width: 100%;
      }
    }
    
    .label-partido {
      position: absolute;
      display: block;
      width: 100%;
      height: 20px;
      margin: 5px 0;
      font-size: 9px;
      font-weight: 900;
      line-height: 1em;
      color: #565656;

      img {
        width: 65%;
        text-align: center;
      }
    }
  }
</style>